import { FIAS_LEVEL } from 'constants/const'
import { AddressErrorsList } from 'feature/addresses/types'
import { TSuggest } from 'feature/registration/types'

type TIsAddressWithError = {
  inputAddress: string
  inputSuggest: TSuggest | null
  setAddressError: (error: AddressErrorsList) => void
}
// проверка на наличие ошибки у адреса
export const isAddressWithError = ({
  inputAddress,
  inputSuggest,
  setAddressError,
}: TIsAddressWithError) => {
  // Пустое поле — не ошибка "адрес не найден" (отдельно проверяется required).
  // Также защищает от ложного срабатывания при первой загрузке формы,
  // когда input ещё не успел прогрузиться из бэка.
  if (!inputAddress || inputAddress.trim().length === 0) {
    return false
  }
  if (inputAddress.length <= 4 || inputAddress !== inputSuggest?.address) {
    setAddressError(AddressErrorsList.addressNotFound)
    return true
  }
  if (+inputSuggest?.fiasLevel < FIAS_LEVEL) {
    setAddressError(AddressErrorsList.addressNotFull)
    return true
  }

  return false
}
